/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoAnalyticsModelsActiveUserListItem,
    MelcoAnalyticsModelsActiveUserListItemFromJSON,
    MelcoAnalyticsModelsActiveUserListItemFromJSONTyped,
    MelcoAnalyticsModelsActiveUserListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem
 */
export interface MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem {
    /**
     * 
     * @type {Array<MelcoAnalyticsModelsActiveUserListItem>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem
     */
    list: Array<MelcoAnalyticsModelsActiveUserListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItemFromJSON(json: any): MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem {
    return MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoAnalyticsModelsActiveUserListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItemToJSON(value?: MelcoModelsGenericList1MelcoAnalyticsModelsActiveUserListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoAnalyticsModelsActiveUserListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


